/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CodaLinkedOutgoingInvoiceDTO { 
    id?: number;
    type?: string;
    invoiceReference?: string;
    customerAccountingNumber?: string;
    invoiceDate?: Date;
    totalIncludingVat?: number;
    currencyCode?: string;
    isProforma?: boolean;
    isCredited?: boolean;
    status?: CodaLinkedOutgoingInvoiceDTO.StatusEnum;
}
export namespace CodaLinkedOutgoingInvoiceDTO {
    export type StatusEnum = 0 | 1 | 2 | 3;
    export const StatusEnum = {
        NUMBER_0: 0 as StatusEnum,
        NUMBER_1: 1 as StatusEnum,
        NUMBER_2: 2 as StatusEnum,
        NUMBER_3: 3 as StatusEnum
    };
}